import { CarItemDto } from '@/api/generated';
import { CarAddModel } from '@/views/cars/list/components/dialog/model/CarAdd.model.ts';
import { CarsListSearchFormModel } from '@/views/cars/list/model/CarsListSearchForm.model.ts';

export type CarsListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: string;
        save: string;
        saveAndAdd: string;
      };
      form: Record<keyof CarAddModel, string>;
      title: {
        create: string;
        update: string;
      };
    };
  };
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<'attention' | keyof Omit<CarItemDto, 'carId'>, string>;
    details: {
      deadlines: string;
      issues: string;
      noDeadlines: string;
      note: string;
      open: string;
      vehicle: string;
      vin: string;
      year: string;
    };
    head: Record<keyof CarsListSearchFormModel, string>;
    quickFilters: {
      active: string;
    };
  };
};

export const carsListTranslation: CarsListTranslation = {
  dialog: {
    add: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
        saveAndAdd: 'Zapisz i dodaj kolejny',
      },
      form: {
        licensePlate: 'Nr rejestracyjny',
        mileage: 'Przebieg',
        model: 'Model',
        note: 'Notatka',
        responsibleUserId: 'Opiekun auta',
        status: 'Status',
        type: 'Rodzaj',
        vin: 'Nr VIN',
        year: 'Rocznik',
      },
      title: {
        create: 'Dodaj auto',
        update: 'Zaktualizuj auto',
      },
    },
  },
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      attention: 'Do zrobienia',
      licensePlate: 'Nr rejestracyjny',
      mileage: 'Przebieg',
      model: 'Model',
      responsibleUser: 'Opiekun',
      status: 'Status',
      type: 'Rodzaj',
    },
    details: {
      deadlines: 'Terminy',
      issues: 'Usterki',
      noDeadlines: 'Brak wpisanych terminów',
      note: 'Notatka',
      open: 'Otwórz auto',
      vehicle: 'Pojazd',
      vin: 'VIN',
      year: 'Rocznik',
    },
    head: {
      fullTextSearchInput: 'Szukaj',
      status: 'Status',
      types: 'Rodzaj',
    },
    quickFilters: {
      active: 'Tylko w użyciu',
    },
  },
};
